import { Component } from '@angular/core';

import _ from 'lodash';
import moment from 'moment-timezone';
import { ToastrService } from 'ngx-toastr';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { Agent, AgentBiddingStats, RfqSessionSupplier } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
	selector: 'pk-broker-agent-auction-info-modal',
	templateUrl: './agent-auction-info-modal.component.html',
	styleUrls: ['./agent-auction-info-modal.component.scss'],
	standalone: false,
})
export class AgentAuctionInfoModalComponent extends AbstractPageForm {
	// input
	public rfqSessionSupplierId: string; // from bidding session
	public agentId: string;

	public stats: AgentBiddingStats;
	public totalAuctionsClosed: number;
	public totalAuctions: number;
	public agent: Agent;
	public sinceDate: moment.Moment;

	constructor(
		private toastrService: ToastrService,
		private graphqlService: GraphqlService,
	) {
		super();
	}

	public async loadPageData(): Promise<void> {
		this.sinceDate = moment().subtract(1, 'year');
		await this.getBrokerBidInfo();
	}

	get title() {
		return this.loggedInUser && this.agent && (this.loggedInUser.isAdmin || this.loggedInUser.agentId) ? this.agent.displayName : 'Broker Info';
	}

	get timeWithName() {
		return this.loggedInUser && this.agent && this.agent.parent && (this.loggedInUser.isAdmin || this.loggedInUser.agentId)
			? this.agent.parent.displayName
			: 'Power Kiosk';
	}

	private async getBrokerBidInfo(): Promise<void> {
		try {
			if (this.rfqSessionSupplierId) {
				this.graphqlService.updateRfqSessionSupplier(this.rfqSessionSupplierId, {
					openedBrokerInfo: true,
				} as RfqSessionSupplier);
			}

			const result = await this.graphqlService.getBrokerBidInfo(this.agentId);
			this.agent = new Agent(result.data.agent);
			this.stats = this.agent.stats;
			this.totalAuctionsClosed = _.sumBy(this.stats.auctionsClosed, s => s.numAuctionsClosed);
			this.totalAuctions = _.sumBy(this.stats.auctions, s => s.numAuctions);
		} catch (e) {
			this.toastrService.warning(
				'There was a problem loading the broker info. We have been notified and are working to fix the issue. ' +
					'Please check back again in 30 minutes.',
				'Broker Info',
			);
		}
	}

	public getAuctionsClosed(serviceTypeId: string): number {
		if (!this.stats || !this.stats.auctionsClosed || !this.stats.auctionsClosed.length) {
			return 0;
		}
		const auctionsClosed = this.stats.auctionsClosed.find(a => a.serviceTypeId === serviceTypeId);
		return auctionsClosed ? auctionsClosed.numAuctionsClosed : 0;
	}

	public getAuctions(serviceTypeId: string): number {
		if (!this.stats || !this.stats.auctions || !this.stats.auctions.length) {
			return 0;
		}
		const auctions = this.stats.auctions.find(a => a.serviceTypeId === serviceTypeId);
		return auctions ? auctions.numAuctions : 0;
	}
}
